/* CozyOfficeCo theme scripts */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents));
    format = format || '${{amount}}';
    function fmt(num, decimals, thousands, decimal) {
      decimals = decimals == null ? 2 : decimals;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var n = (num / 100).toFixed(decimals);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }

  /* ---------- Product section ---------- */
  function initProduct(root) {
    var cfgEl = root.querySelector('[data-cz-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var form = root.querySelector('[data-cz-form]');
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-cz-tier]'));
    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-cz-addon]'));
    var totalEls = root.querySelectorAll('[data-cz-total], [data-cz-sticky-total]');
    var atc = root.querySelector('[data-cz-atc]');
    var errorEl = root.querySelector('[data-cz-error]');

    function selectedTier() {
      return tiers.filter(function (t) { return t.classList.contains('is-selected'); })[0] || tiers[0];
    }

    function computeTotal() {
      var t = selectedTier();
      var qty = Number(t.dataset.qty || 1);
      var disc = Number(t.dataset.discount || 0);
      var total = Math.round(cfg.unitPrice * qty * (100 - disc) / 100);
      addons.forEach(function (a) { if (a.checked) total += Number(a.dataset.price); });
      return total;
    }

    function render() {
      var total = formatMoney(computeTotal(), cfg.moneyFormat);
      totalEls.forEach(function (el) { el.textContent = total; });
    }

    tiers.forEach(function (tier) {
      var radio = tier.querySelector('input[type=radio]');
      function choose() {
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tier.classList.add('is-selected');
        radio.checked = true;
        render();
      }
      radio.addEventListener('change', choose);
      tier.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        choose();
      });
    });
    addons.forEach(function (a) { a.addEventListener('change', render); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = selectedTier();
      var counts = {};
      var selects = t.querySelectorAll('[data-cz-variant]');
      if (selects.length) {
        selects.forEach(function (s) { counts[s.value] = (counts[s.value] || 0) + 1; });
      } else {
        counts[root.dataset.defaultVariant || ''] = Number(t.dataset.qty);
      }
      var items = Object.keys(counts).filter(Boolean).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
      addons.forEach(function (a) { if (a.checked) items.push({ id: Number(a.value), quantity: 1 }); });
      if (!items.length) return;

      atc.disabled = true;
      atc.classList.add('is-loading');
      errorEl.hidden = true;
      fetch(cfg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
          window.location.href = cfg.afterAdd === 'checkout' ? '/checkout' : cfg.cartUrl;
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          atc.disabled = false;
          atc.classList.remove('is-loading');
        });
    });

    // Sticky bar
    var sticky = root.querySelector('[data-cz-sticky]');
    var stickyBtn = root.querySelector('[data-cz-sticky-btn]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
      stickyBtn.addEventListener('click', function () {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    render();
  }

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    var track = g.querySelector('[data-cz-track]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-cz-thumb]'));
    if (!track) return;
    function go(i) {
      var slides = track.children;
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.czThumb)); }); });
    var prev = g.querySelector('[data-cz-prev]');
    var next = g.querySelector('[data-cz-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var c = current();
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === c); });
        var active = thumbs[c];
        if (active && active.parentNode.scrollTo) {
          active.parentNode.scrollTo({ left: active.offsetLeft - 40, behavior: 'smooth' });
        }
      });
    });
  }

  /* ---------- Delivery timeline ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  }
  function initTimeline(el) {
    var fmt = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
    var now = new Date();
    var ship = addBusinessDays(now, Number(el.dataset.process));
    var min = addBusinessDays(ship, Number(el.dataset.min));
    var max = addBusinessDays(ship, Number(el.dataset.max));
    el.querySelector('[data-cz-date="0"]').textContent = fmt(now);
    el.querySelector('[data-cz-date="1"]').textContent = fmt(ship);
    el.querySelector('[data-cz-date="2"]').textContent = fmt(min) + ' – ' + fmt(max);
  }

  /* ---------- Popups ---------- */
  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, val);
    } catch (e) { return null; }
  }
  function openModal(m) {
    m.hidden = false;
    requestAnimationFrame(function () { m.classList.add('is-open'); });
    var f = m.querySelector('input, button');
    if (f) f.focus({ preventScroll: true });
  }
  function closeModal(m) {
    m.classList.remove('is-open');
    setTimeout(function () { m.hidden = true; }, 250);
  }
  function initPopups() {
    var member = document.querySelector('[data-cz-member]');
    var exit = document.querySelector('[data-cz-exit]');
    var anyOpen = function () { return document.querySelector('.cz-modal.is-open'); };

    [member, exit].forEach(function (m) {
      if (!m) return;
      m.addEventListener('click', function (e) {
        if (e.target === m || e.target.closest('[data-cz-close]')) closeModal(m);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) closeModal(m); });
    });

    if (member) {
      if (member.dataset.success === 'true') {
        store('cz_member', 'joined');
        openModal(member);
      } else if (!store('cz_member') && !document.body.classList.contains('template-cart')) {
        setTimeout(function () {
          if (!anyOpen()) { openModal(member); store('cz_member', 'seen'); }
        }, Number(member.dataset.delay || 8) * 1000);
      }
    }

    if (exit && !store('cz_exit')) {
      var fire = function () {
        if (store('cz_exit') || anyOpen()) return;
        store('cz_exit', '1');
        openModal(exit);
      };
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) fire();
      });
      // Mobile: show when a shopper who scrolled deep heads back up quickly
      var peak = 0;
      window.addEventListener('scroll', function () {
        if (window.innerWidth >= 750) return;
        peak = Math.max(peak, window.scrollY);
        if (peak > 1500 && window.scrollY < peak - 900) fire();
      }, { passive: true });
    }

    document.querySelectorAll('[data-cz-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.dataset.czCopy;
        if (navigator.clipboard) navigator.clipboard.writeText(code);
        b.textContent = 'Copied!';
      });
    });
  }

  function init() {
    document.querySelectorAll('.cz-product').forEach(initProduct);
    document.querySelectorAll('[data-cz-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-cz-timeline]').forEach(initTimeline);
    initPopups();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
